import React, { Component } from "react";
import tableIcons from "./MaterialTableIcons";
import Button from "../Button";
import { DocumentMinusIcon } from "@heroicons/react/24/solid";
import {
  TablePagination,
  TablePaginationTypeMap,
  TablePaginationBaseProps,
} from "@material-ui/core";
import CustomLoader from "../CustomLoader";
import MaterialTable, {
  MaterialTableProps,
  MTableToolbar,
} from "material-table";
import DeactivateButton from "../DeactivateButton";

const defaultHeaderStyle = {
  color: "#203A75",
  fontWeight: "bold",
  fontSize: "12px",
  whiteSpace: "nowrap",
  center: true,
} as React.CSSProperties;

const defaultRowStyle = {
  whiteSpace: "nowrap",
  fontSize: "12px",
} as React.CSSProperties;

interface ITablePagination
  extends TablePaginationTypeMap<TablePaginationBaseProps, React.ElementType> {
  ActionsComponent?: any[];
  onChangePage?: any[];
  onChangeRowsPerPage?: any;
}
const PatchedPagination: React.FC<ITablePagination> = ({
  ActionsComponent,
  onChangePage,
  onChangeRowsPerPage,
  ...tablePaginationProps
}) => {
  return (
    <TablePagination
      {...tablePaginationProps}
      // @ts-expect-error onChangePage was renamed to onPageChange
      onPageChange={onChangePage}
      SelectProps={{
        IconComponent: () => <div></div>,
      }}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={(subprops) => {
        const { onPageChange, ...actionsComponentProps } = subprops;
        return (
          // @ts-expect-error ActionsComponent is provided by material-table
          <ActionsComponent
            {...actionsComponentProps}
            onChangePage={onPageChange}
          />
        );
      }}
    />
  );
};

interface IMaterialTableTS extends MaterialTableProps<object> {
  showTitle?: boolean;
  showHeader?: boolean;
  headerStyle?: React.CSSProperties;
  rowStyle?: React.CSSProperties;
  showToolbar?: boolean;
  toolbarSearch?: boolean;
  searchFieldAlignment?: "left" | "right";
  tableRef?: any;
  paging?: boolean;
  doubleHorizontalScroll?: boolean;
  pageSize?: number;
  selectedRows?: any;
  selection?: boolean;
  setConfirmModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  onSelectionChange?: ((data: any[], rowData?: any) => void) | undefined;
  grouping?: boolean;
  groupedBy?: React.ReactNode;
  exportButton?: boolean;
  toolBarComponent?: any;
}
const MaterialTableTS: React.FC<IMaterialTableTS> = ({
  data,
  isLoading,
  columns,
  showTitle = false,
  toolbarSearch,
  showHeader = true,
  headerStyle = defaultHeaderStyle,
  rowStyle = defaultRowStyle,
  showToolbar = false,
  searchFieldAlignment = "left",
  tableRef,
  paging = true,
  doubleHorizontalScroll = true,
  pageSize = 10,
  selection,
  selectedRows = [],
  setConfirmModalOpen,
  onSelectionChange,
  grouping,
  groupedBy,
  exportButton,
  toolBarComponent,
  ...props
}) => {
  return (
    <div>
      <div>
        {" "}
        {selectedRows.length > 0 && (
          <div className="flex justify-start mr-2 pb-2">
            <DeactivateButton
              className={""}
              onClickFunction={() => {
                setConfirmModalOpen && setConfirmModalOpen(true);
              }}
              disabled={false}
            >
              <>
                <DocumentMinusIcon className="h-4 w-4 font-bold " />
                Deactivate
              </>
            </DeactivateButton>
            <div className="mt-1 ml-2 text-xs text-primary ">
              Deactivate Selected Row/s
              <p className="inline-block font-bold">({selectedRows.length})</p>
            </div>
          </div>
        )}
      </div>
      <MaterialTable
        data={data}
        isLoading={isLoading}
        columns={columns}
        onSelectionChange={(rows) => {
          onSelectionChange && onSelectionChange(rows);
        }}
        options={{
          header: showHeader,
          exportButton: exportButton
            ? { csv: exportButton, pdf: false }
            : false,
          selection: selection,
          search: toolbarSearch,
          showTitle: showTitle,
          searchFieldAlignment: searchFieldAlignment,
          headerStyle: headerStyle,
          toolbar: showToolbar,
          rowStyle: rowStyle,
          padding: "dense",
          paging: paging,
          // doubleHorizontalScroll: doubleHorizontalScroll,
          pageSize: pageSize,
          pageSizeOptions: [10, 20, 30, 40, 50],
          showTextRowsSelected: false,
          selectionProps: (rowData) => {
            const checked = rowData.tableData.checked
              ? (rowData.agreementIsActive === true &&
                  rowData.isActive === true) ||
                rowData.status === true ||
                rowData.isActive === true ||
                rowData.isActive === "true" ||
                rowData.isActive === "Active" ||
                rowData.isInActive === false ||
                rowData?.status === true ||
                (!rowData.agreementIsActive && rowData.isActive === true)
                ? { checked: true }
                : { checked: false }
              : {};
            return {
              disabled:
                rowData.isActive === false ||
                rowData?.status === false ||
                rowData.isActive === "Inactive" ||
                rowData.isInActive === true ||
                rowData.status === "Terminated" ||
                rowData.isActive === "false" ||
                rowData.status === "Inactive" ||
                rowData.agreementIsActive === false,
              ...checked,
            };
          },
        }}
        localization={{
          body: {
            emptyDataSourceMessage: isLoading ? (
              <CustomLoader />
            ) : (
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                No records to display.
              </label>
            ),
          },
        }}
        components={{
          Pagination: PatchedPagination,
          OverlayLoading: () => <></>,
        }}
        style={{ overflowX: "auto" }}
        icons={tableIcons}
        tableRef={tableRef}
        {...props}
      />
    </div>
  );
};

export default MaterialTableTS;
